"use strict";

/**
* Предоставляет инструменты для сбора и отправки статистики по взаимодействию пользователя с веб-страницей.
* Например, пользователь перешел по ссылке из карточки задачи или нажал на кнопку «Создать папку» на странице проводника веб-доступа.
*
* @namespace WebAccess.current.statistics
* @property {boolean} saveImmediate Признак автоматического сохранения статистики после каждого действия
* @property {int} maxStackSize Размер пакета для отправки статистики
* @since 5.1.0.1300
*/

(function (global) {
  $('document').ready(function () {
    var statistics = {

      saveImmediate: false,

      debounceInterval: window.STATISTICS.DEBOUNCE_INTERVAL,
      requestInterval: window.STATISTICS.REQUEST_INTERVAL,
      stackSize: window.STATISTICS.STACK_SIZE,

      _eventTimestamp: 0,
      _queueTimestamp: 0,

      _isDisabled: true,

      _ignoredActions: [
        'sidebar_container',
        'caption_container',
        'tree_container',
        'toolbar_container',
        'logo_container',
        'main_container',
        'left_column',
        'QFilter',
        'reference_footer',
        'ctl00_MainContent_CardContainer',
        'ctl00_MainContent_CardControl_ctl00',
        'ctl00_MainContent_RefRecTable_GridCtrl',
        'ctl00_MainContent_Attachments_AttachmentsList_list',
        'ctl00_MainContent_CardControl',
        'ModalWindow',
        'ModalWindowContent',
        'info',
        'ToolbarSeparator',
        'header',
        'ui-datepicker-div',
        'SelectedRightsRow',
        'InstructionText',
        'content_list_toolbox',
        'lblEmpty', 'pnlEmpty',
        'ListRequisiteOuterPanel',
        'Requisite', 'Requisite (disabled)',
        'WizardPanelForm',
        'StatOff', 'StatOff (disabled)'],

      _ignoredAreas: [
        'CustomWorkTree',
        'ColumnFilterDialog'
      ]
    };

    /**
    * Включить сбор статистики.
    *
    * @method WebAccess.current.statistics.enable
    * @return {WebAccess.current.statistics} Объект типа statistics.
    * @since 5.1.0.1300
    */
    statistics.enable = function () {
      this._isDisabled = false;
      return this;
    };

    /**
    * Отключить сбор статистики.
    *
    * @method WebAccess.current.statistics.disable
    * @return {WebAccess.current.statistics} Объект типа statistics.
    * @since 5.1.0.1300
    */
    statistics.disable = function () {
      this._isDisabled = true;
      return this;
    };

    /**
    * Проверить, отключен ли механизм сбора статистики.
    *
    * @method WebAccess.current.statistics.isDisabled
    * @return {boolean} True – механизм сбора статистики отключен, иначе False.
    * @since 5.1.0.1300
    */
    statistics.isDisabled = function () {
      return this._isDisabled;
    };
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавить информацию об HTML-объекте в журнал сбора статистики веб-доступа.
    *
    * @method WebAccess.current.statistics.write
    * @param {Object} HTMLelement HTML-объект, информация о котором записывается в журнал сбора статистики
    * @param {Object} [opt_actionTarget] HTML-объект, для которого было вызвано действие в веб-доступе
    * @return {WebAccess.current.statistics} Объект типа statistics.
    * @since 5.1.0.1300
    *
    * @example <caption> Записать действия пользователя, выполняемые на панели инструментов веб-доступа.</caption>
    * WA.CR.statistics.enable();
    * $("#toolbar_container").on('mousedown.stat', function (event) {
    *   WA.CR.statistics.write(event.target);
    * });
    */
    statistics.write = function (HTMLelement, opt_actionTarget) {
      if (this._isDisabled || WA.getLocation() === 'login') {
        return this;
      }

      const eventParams = this._getParams(HTMLelement, opt_actionTarget);
      if (!eventParams || !eventParams.Action) {
        return this;
      }

      if (this.saveImmediate) {
        WA.SRV.request('/ClientStatistic.asmx/Write', eventParams, { hideSpinner: true });
      } else {
        let eventQueue = WA.cache.getObject('statistics') || [];
        const dateNow = Date.now();
        if (!eventQueue.length) {
          this._queueTimestamp = dateNow;
        }
        // если debounceInterval удовлетворён, добавляем событие, если нет -- перезаписываем последнее
        if ((dateNow - this._eventTimestamp) >= this.debounceInterval) {
          this._eventTimestamp = Date.now();
          eventQueue.push(eventParams);
        } else {
          eventQueue.splice(-1, 1, eventParams);
        }

        WA.cache.setObject('statistics', eventQueue);
        if (eventQueue.length >= this.stackSize && (dateNow - this._queueTimestamp) >= this.requestInterval) {
          this.writeQueue();
        }
      }

      return this;
    };
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить параметры пригодные для статистики указанного элемента
    * @private
    */
    statistics._getParams = function (HTMLelement, opt_actionTarget) {
      opt_actionTarget = opt_actionTarget || HTMLelement;
      var stat = global.current.statistics;
      var params = { 'Time': new Date() };

      if (HTMLelement.tagName) {
        var actionAndArea = stat._getActionAndAreas(HTMLelement, true);

        params.Page = WA.getLocation();
        params.Action = actionAndArea.action;
        params.Area = (actionAndArea.areas.length > 0 ? actionAndArea.areas[0] : '');
        params.Target = stat._getTargetAndAreas(opt_actionTarget);
      } else {
        params.Page = HTMLelement.page;
        params.Action = HTMLelement.action;
        params.Area = HTMLelement.area;
        params.Target = stat._getTargetAndAreas(HTMLelement.target);
      }

      if (params.Action == '' || $.inArray(params.Action, this._ignoredActions) !== -1) return;
      if (params.Area == '' || $.inArray(params.Area, this._ignoredAreas) !== -1) return;

      return params;
    };
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Выгрузить текущий пакет статистики на сервер веб-доступа.
    *
    * @method WebAccess.current.statistics.writeQueue
    * @return {WebAccess.current.statistics} Объект типа statistics.
    * @since 5.1.0.1300
    */
    statistics.writeQueue = function () {
      if (this._isDisabled) {
        return this;
      }

      const params = Object.freeze({
        Queue: [...WA.cache.getObject('statistics')],
      });
      WA.SRV.request('/ClientStatistic.asmx/WriteQueue', params, { hideSpinner: true }).error((error) => {
        WA.SRV.request('/ClientStatistic.asmx/Write', {
          Action: `Failed to send statistics queue of size ${params.length}`,
          Area: error,
          Page: WA.getLocation(),
          Target: '/ClientStatistic.asmx/WriteQueue',
          Time: Date.now(),
        }, { hideSpinner: true });
      });

      WA.cache.removeItem('statistics');

      return this;
    };

    /**
    * Загружает информацию об окружении клиента на сервер веб-доступа.
    *
    * @method WebAccess.current.statistics.writeEnvironment
    * @return {WebAccess.current.statistics} Объект типа statistics.
    * @since 5.8.2.3000
    */
    statistics.writeEnvironment = function () {
      if (this._isDisabled) {
        return this;
      }

      WA.SRV.request('/ClientStatistic.asmx/WriteEnvironment', {
        BrowserName: WA.ENV.browser.name,
        BrowserVersion: WA.ENV.browser.version,
        OperationSystemFamily: WA.ENV.os.name,
        OperationSystemVersion: WA.ENV.os.version ? WA.ENV.os.version : '',
        CpuArchitecture: WA.ENV.cpu.architecture ? WA.ENV.cpu.architecture : 'x86',
        WebAccessVersion: 'undefined'
      }, { hideSpinner: true });

      return this;
    };
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получение имени элемента и имени области в которой произошло событие
    * @method WebAccess.current.statistics._getActionAndAreas
    * @param {HTMLElement}
    * @param {returnFirstOnly} вернуть только первую найденную область в виде строки
    * @private
    * @since 5.1.0.1300
    */
    statistics._getActionAndAreas = function (target, returnFirstOnly) {
      var me = this;
      var result = {
        action: '',
        areas: []
      };
      var isDisabled = '';

      var curr = target;
      while (curr) {
        // Проверяем есть ли область.
        if (curr.className) {
          var className = (typeof curr.className.baseVal === 'undefined' ? curr.className : curr.className.baseVal);
          // Проверяем тип className, т.к. для svg use className может вернуть объект.
          if (className && typeof className === 'string' && className.indexOf('stat_') !== -1) {
            result.areas.push(me._getAreaFromElement(curr, returnFirstOnly));
            // Если нашли область, то действие должно было быть в пределах этой области и не важно нашли мы его или нет. Если не нашли, значит искать выше уже нет смысла.
            if (returnFirstOnly) return result;
          }
        }

        // Если мы действие уже нашли, то оставляем его. Дальше будет искаться только область.
        if (result.action == '') {
          if (className && className.toLowerCase().indexOf('disabled') !== -1) isDisabled = ' (disabled)';
          if (curr.getAttribute) {
            if (curr.getAttribute('data-stataction')) {
              result.action = curr.getAttribute('data-stataction') + isDisabled;
            } else
              if (curr.getAttribute('name')) {
                result.action = curr.getAttribute('name') + isDisabled;
              } else
                if (curr.getAttribute('data-name')) {
                  result.action = curr.getAttribute('data-name') + isDisabled;
                } else
                  if (curr.getAttribute('id')) {
                    result.action = curr.getAttribute('id') + isDisabled;
                  }
          }
        }

        curr = curr.parentNode;
      }

      return result;
    };
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить имя конкретной области
    * @private
    */
    statistics._getAreaFromElement = function (areaElement, returnFirstOnly) {
      var cNames;
      var cName;
      cNames = areaElement.className.split(' ');
      for (var m = 0; m < cNames.length; m++) {
        cName = cNames[m];
        if (cName.indexOf('stat_') === -1) continue;
        return cName.replace('stat_', '');
      }
    };
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получение DOM-цепочки к элементу
    * @method WebAccess.current.statistics._getTargetAndAreas
    * @private
    * @since 5.1.0.1300
    */
    statistics._getTargetAndAreas = function (HTMLelement) {
      var stat = global.current.statistics;
      var actionAndAreas = stat._getActionAndAreas(HTMLelement);
      return ([actionAndAreas.action].concat(actionAndAreas.areas)).join(',');
    };

    global.current.statistics = statistics;
  });

})(window.WebAccess);